import { NumberChoiceModel, StringChoiceModel } from "models/ChoiceModel";
import { useTranslations } from "providers";
import React, { PropsWithChildren, useMemo } from "react";

import { EnumChoicesContext, EnumChoicesContextProps } from "./EnumChoicesContext";
import { getAddAgendaItemPositions } from "./getAddAgendaItemPositions";
import { getAgendaItemStatuses } from "./getAgendaItemStatuses";
import { getBoardStatuses } from "./getBoardStatuses";
import { getMeetingStatuses } from "./getMeetingStatuses";
import { getParticipantRoles } from "./getParticipantRoles";
import { getParticipantStatuses } from "./getParticipantStatuses";
import { getTaskStatuses } from "./getTaskStatuses";

export const EnumChoicesProvider: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const i18n = useTranslations();

  const addAgendaItemPositions = useMemo<NumberChoiceModel[]>(() => getAddAgendaItemPositions(i18n), [i18n]);
  const boardStatuses = useMemo<NumberChoiceModel[]>(() => getBoardStatuses(i18n), [i18n]);
  const meetingStatuses = useMemo<NumberChoiceModel[]>(() => getMeetingStatuses(i18n), [i18n]);
  const agendaItemStatuses = useMemo<NumberChoiceModel[]>(() => getAgendaItemStatuses(i18n), [i18n]);
  const taskStatuses = useMemo<NumberChoiceModel[]>(() => getTaskStatuses(i18n), [i18n]);
  const participantStatuses = useMemo<NumberChoiceModel[]>(() => getParticipantStatuses(i18n), [i18n]);
  const participantRoles = useMemo<StringChoiceModel[]>(() => getParticipantRoles(i18n), [i18n]);

  const value = useMemo<EnumChoicesContextProps>(
    () => ({
      addAgendaItemPositions,
      boardStatuses,
      meetingStatuses,
      agendaItemStatuses,
      taskStatuses,
      participantStatuses,
      participantRoles,
    }),
    [
      addAgendaItemPositions,
      boardStatuses,
      meetingStatuses,
      agendaItemStatuses,
      taskStatuses,
      participantStatuses,
      participantRoles,
    ]
  );

  return <EnumChoicesContext.Provider value={value}>{children}</EnumChoicesContext.Provider>;
};
